import { STORAGE_KEYS } from './constants.js';

export const storage = {
  // JWT tokens
  setJWT: (token) => {
    localStorage.setItem(STORAGE_KEYS.JWT, token);
  },
  
  getJWT: () => {
    return localStorage.getItem(STORAGE_KEYS.JWT);
  },
  
  setSendOtpJWT: (token) => {
    localStorage.setItem(STORAGE_KEYS.SEND_OTP_JWT, token);
  },
  
  getSendOtpJWT: () => {
    return localStorage.getItem(STORAGE_KEYS.SEND_OTP_JWT);
  },
  
  setVerifyOtpJWT: (token) => {
    localStorage.setItem(STORAGE_KEYS.VERIFY_OTP_JWT, token);
  },
  
  getVerifyOtpJWT: () => {
    return localStorage.getItem(STORAGE_KEYS.VERIFY_OTP_JWT);
  },
  
  // User profile
  setUserProfile: (profile) => {
    localStorage.setItem(STORAGE_KEYS.USER_PROFILE, JSON.stringify(profile));
  },
  
  getUserProfile: () => {
    const profile = localStorage.getItem(STORAGE_KEYS.USER_PROFILE);
    return profile ? JSON.parse(profile) : null;
  },
  
  // Projects
  setProjects: (projects) => {
    // Ensure project_id is stored as number
    const processedProjects = projects.map(project => ({
      ...project,
      project_id: Number(project.project_id)
    }));
    localStorage.setItem(STORAGE_KEYS.PROJECTS, JSON.stringify(processedProjects));
  },
  
  getProjects: () => {
    const projects = localStorage.getItem(STORAGE_KEYS.PROJECTS);
    if (projects) {
      const parsedProjects = JSON.parse(projects);
      // Ensure project_id remains as number
      return parsedProjects.map(project => ({
        ...project,
        project_id: Number(project.project_id)
      }));
    }
    return [];
  },
  
  updateProject: (projectId, updates) => {
    const projects = storage.getProjects();
    const updatedProjects = projects.map(project => 
      project.project_id === Number(projectId) 
        ? { ...project, ...updates }
        : project
    );
    storage.setProjects(updatedProjects);
  },
  
  addProject: (project) => {
    const projects = storage.getProjects();
    const newProject = {
      ...project,
      project_id: Number(project.project_id)
    };
    projects.push(newProject);
    storage.setProjects(projects);
  },
  
  // Clear all data
  clearAll: () => {
    Object.values(STORAGE_KEYS).forEach(key => {
      localStorage.removeItem(key);
    });
  },
  
  // Clear temporary tokens
  clearTemporaryTokens: () => {
    localStorage.removeItem(STORAGE_KEYS.SEND_OTP_JWT);
    localStorage.removeItem(STORAGE_KEYS.VERIFY_OTP_JWT);
  }
};